import { getLevels, treePosition, initTreePosition } from './sidebar';

const navigateBackward = (newPos: number): void => {
  for (let i = 0; i < newPos; i++) treePosition.pop();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  renderPosition();
};

const navigateForward = (newPos: number): void => {
  treePosition.push(newPos);
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  renderPosition();
};

const resetPosition = (): void => {
  treePosition.length = 0;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  renderPosition();
};

/**
 * Safely build a li>a structure that in contrast to string concat doesn't allow HTML injection
 */
function buildNavLink({
  href,
  click,
  html,
}: {
  href?: string;
  click?: JQuery.EventHandlerBase<HTMLElement, JQuery.ClickEvent<HTMLElement, null, HTMLElement, HTMLElement>>;
  html: string;
}) {
  const li = $('<li><a></a></li>');
  const a = li.children('a');
  if (href) {
    a.attr('href', href);
  }
  if (click) {
    a.click(click);
  }
  // This is actually an unsafe operation but we trust the content here as liferay
  // wil geneate html entities
  a.html(html);
  return li;
}

const renderPosition = (): void => {
  $('#sm-nav-breadcrumbs, #sm-nav-links').empty();

  if (treePosition && !treePosition.length) {
    $('#sm-nav-breadcrumbs, #sm-nav-links').addClass('d-none');
    $('#sm-nav-header-links, #sm-nav-sidebar-links').removeClass('d-none');
    return;
  }

  $('#sm-nav-breadcrumbs, #sm-nav-links').removeClass('d-none');
  $('#sm-nav-header-links, #sm-nav-sidebar-links').addClass('d-none');

  const computedLevels = getLevels();

  if (computedLevels.length === 0) {
    return;
  }

  // Determines which level is a level without sub-sites
  if (computedLevels.length > 1 && !computedLevels[computedLevels.length - 1].browsableChildren.length) {
    computedLevels.pop();
    treePosition.pop();
  }

  const lastElementId = computedLevels.length - 1;

  // Build nav links
  const navLinks = $('#sm-nav-links');
  const breadcrumbs = $('#sm-nav-breadcrumbs');
  navLinks.append(buildNavLink({ href: computedLevels[lastElementId].URL, html: computedLevels[lastElementId].name }));
  navLinks.append(buildNavLink({ href: computedLevels[lastElementId].URL, html: 'Übersicht' }));

  const clBcEntries = computedLevels[lastElementId].browsableChildren;
  for (let i = 0; i < clBcEntries.length; i++) {
    const sublink = clBcEntries[i];

    if (sublink.browsableChildren.length)
      navLinks.append(buildNavLink({ click: () => navigateForward(i), html: sublink.name }));
    else navLinks.append(buildNavLink({ href: sublink.URL, html: sublink.name }));
  }

  // Build breadcrumbs
  const entries = computedLevels.reverse();
  for (let i = 0; i < entries.length; i++) {
    const level = entries[i];

    if (!i) continue;

    breadcrumbs.prepend(buildNavLink({ click: () => navigateBackward(i), html: level.name }));
  }

  breadcrumbs.prepend($('<li><a>Hauptmenu</a></li>').click(() => resetPosition()));
};

const addEventListenerToNavElements = (): void => {
  const $navigationElement = $('#sm-nav-header-links [data-function="navigate-forward"]');
  $navigationElement.each((_i, element) => {
    element.addEventListener('click', () => navigateForward(Number(element.dataset.index)));
  });
};

const isActiveClassName = 'is-active';
const isActiveClassTargets = '#burger-button, #sm-nav-expanded, #nav-burger-button, .main-content';

let navExpanded = false;

window.addEventListener('popstate', () => {
  // Note: when we use push/popstate in other places of this website this might get buggy was we removeClass on
  // every popState
  // To change this we'd need to keep track of each state change
  navExpanded = window.history.state && window.history.state.mobileNavOpen === true;
  if (navExpanded) {
    $(isActiveClassTargets).addClass(isActiveClassName);
  } else {
    $(isActiveClassTargets).removeClass(isActiveClassName);
  }
});

export const initMobileNav = (): void => {
  // initially get tree position based on elements
  initTreePosition();

  let prevScrollPos = window.pageYOffset;

  addEventListenerToNavElements();
  renderPosition();

  if (window.history && window.history.state && window.history.state.mobileNavOpen === true) {
    $(isActiveClassTargets).addClass(isActiveClassName);
  }

  $('#nav-burger-button').on('click', () => {
    // open navigation expand when closed and vice versa
    navExpanded = !navExpanded;

    if (navExpanded) {
      if (window.history && window.history.pushState) {
        window.history.pushState({ mobileNavOpen: true }, null);
      }
      $(isActiveClassTargets).addClass(isActiveClassName);
    } else {
      if (window.history && window.history.state && window.history.state.mobileNavOpen === true) {
        window.history.back();
      }
      $(isActiveClassTargets).removeClass(isActiveClassName);
    }
  });

  $(document).on('scroll', () => {
    const currentScrollPos = window.pageYOffset;

    if (prevScrollPos > currentScrollPos) {
      $('.sm-nav').css('bottom', 0);
      $('.burger-menu-icon').removeClass('floating');
    } else {
      $('.sm-nav').css('bottom', `-${$('.sm-nav').outerHeight()}px`);
      $('.burger-menu-icon').addClass('floating');
    }

    if (currentScrollPos > 0) {
      // iOS negative scrolling
      prevScrollPos = currentScrollPos;
    }
  });
};
